export default __webpack_public_path__ + "static/media/plain-sticker-s.63d49f4b.png";